import { downloadCertificateBatch } from "../../../services/CertificateBatchService";
import { batchFileName } from "../../../helpers/CertificateBatchHelper";
import { saveFile } from "../../../helpers/SaveFile";
import { readErrorBody } from "../../../helpers/ErrorMessage";
import { CERTIFICATE_BATCH_DOWNLOAD_ERROR_MESSAGES } from "../../../constants/CertificateBatchConstants";

// Fetches the batch ZIP (the API records the download) and saves it.
const downloadBatch = async (id) => {
  const response = await downloadCertificateBatch(id);
  saveFile(response.data, batchFileName(response.headers || {}));
};

// The message (an i18n id) for the reason the API gave for a failed
// download, or null when it gave none. The file is requested as a Blob, so
// the error body arrives as one and is read for the API's code
// (CERTIFICATE_BATCH_FILE_MISSING: the ZIP is gone from storage).
export const downloadFailureMessageId = async (error) => {
  const body = await readErrorBody(error?.response?.data);
  return CERTIFICATE_BATCH_DOWNLOAD_ERROR_MESSAGES[body.response] || null;
};

export default downloadBatch;
